<template>
  <div v-editable="props.blok" :class="`wp-button ${props.blok.type}`" :data-uid="props.blok._uid">
    <a :href="calcedLink" :rel="props.blok.link?.rel" :target="props.blok.link?.target">
      <PflegeButton
        :variant="props.blok.type"
        :title="props.blok.link ? props.blok.link.title : null"
        :label="props.blok.label"
        :icon="props.blok.icon"
        :icon-position="props.blok.iconPosition"
      />
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  blok: {
    type: Object,
    required: true
  }
})

const calcedLink = computed(() => {
  if (!props.blok.link || !props.blok.link.cached_url) {
    return null
  }
  let link = props.blok.link.cached_url
  if (props.blok.link.linktype === 'asset') {
    link = (link || '').replace('//a.storyblok.com', '//assets.pflege.de')
  }
  if (props.blok.link.anchor) {
    link += `#${props.blok.link.anchor}`
  }
  return link
})
</script>

<style scoped>
.wp-button {
  text-align: v-bind('props.blok.align');
  margin-block: 1rem;
}
</style>
